import React from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import './Auth.css';

const CheckEmailPage = () => {
  const location = useLocation();
  const email = location.state?.email || 'your email';

  return (
    <div className="auth-container">
      <div className="auth-wrapper">
        <div className="auth-card">
          <div className="auth-header">
            <h1 className="auth-title">📧 Check Your Email</h1>
            <p className="auth-subtitle">We sent a verification link to {email}</p>
          </div>

          <div className="verification-content">
            <div style={{
              background: '#e0f2fe',
              border: '1px solid #0284c7',
              padding: '20px',
              borderRadius: '8px',
              textAlign: 'center',
              marginBottom: '20px'
            }}>
              <p style={{ margin: '0 0 10px 0', fontSize: '14px', color: '#075985' }}>
                ✅ Account created successfully!
              </p>
              <p style={{ margin: '0', fontSize: '13px', color: '#075985' }}>
                Click the link in the email to verify your account. The link expires in 1 hour.
              </p>
            </div>
          </div>

          <div className="auth-links">
            <p style={{ textAlign: 'center', color: '#666', marginBottom: '15px' }}>
              Didn't receive the email? Check your spam folder.
            </p>
            <Link to="/login" className="auth-link">
              Back to Sign In
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckEmailPage;